import styled from "styled-components/macro";
import { colorPalette as colors, ColorNames, fonts } from "src/theme/theme";

export const InvestmentDetailImg = styled.img`
  width: 100%;
  border-radius: 4px;
  margin-bottom: 30px;
`;
